import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TopPurchasedData } from 'components/KBQSelect'

const initialState: TopPurchasedData[] = []

const kbqTopPurchasedDataSlices = createSlice({
  name: 'KBQTopPurchasedData',
  initialState,
  reducers: {
    setKBQTopPurchasedData(state, action: PayloadAction<TopPurchasedData>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
  },
})

export const { setKBQTopPurchasedData } = kbqTopPurchasedDataSlices.actions

export default kbqTopPurchasedDataSlices.reducer
